webpackJsonp([212865419962061],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n'], ['\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  align-items: center;\n  div {\n    background-image: url(/social/', '-white.svg);\n    background-repeat: no-repeat;\n    background-size: 100%;\n    width: 18px;\n    height: 18px;\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  div {\n    background-image: url(/social/', '-white.svg);\n    background-repeat: no-repeat;\n    background-size: 100%;\n    width: 18px;\n    height: 18px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _designSystem = __webpack_require__(4);
	
	var _lodash = __webpack_require__(120);
	
	var _Nav = __webpack_require__(48);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Action = __webpack_require__(64);
	
	var _Action2 = _interopRequireDefault(_Action);
	
	var _Footer = __webpack_require__(47);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sheet = _designSystem.Card.withComponent(_designSystem.Container).extend(_templateObject);
	
	var url = 'http://hackpenn.com/';
	var twitterURL = function twitterURL(text) {
	  var u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : url;
	  return 'https://twitter.com/intent/tweet?text=' + text.split(' ').join('%20') + '&url=' + u;
	};
	var facebookURL = function facebookURL(text) {
	  var u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : url;
	  return 'https://www.facebook.com/sharer/sharer.php?u=' + u;
	};
	
	var InlineButton = _designSystem.Button.extend(_templateObject2, function (props) {
	  return (0, _lodash.lowerCase)(props.service).split(' ').join('');
	});
	var ShareButton = function ShareButton(_ref) {
	  var children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    InlineButton,
	    _extends({
	      target: '_blank',
	      'aria-label': 'Share on ' + props.service,
	      f: 2
	    }, props),
	    _react2.default.createElement(_designSystem.Box, { mr: 2 }),
	    children || props.service
	  );
	};
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Nav2.default, null),
	    _react2.default.createElement(
	      _designSystem.Box,
	      { px: 3, pt: [5, 6], pb: 5, bg: 'cool' },
	      _react2.default.createElement(
	        _designSystem.Container,
	        { maxWidth: 36, color: 'white', align: 'center', px: 3 },
	        _react2.default.createElement(
	          _designSystem.Heading.h1,
	          { f: [6, 7], mb: 2 },
	          'Register'
	        ),
	        _react2.default.createElement(
	          _designSystem.Heading.h2,
	          { f: [3, 4], m: 0 },
	          _react2.default.createElement(
	            _designSystem.Text.span,
	            { bg: 'warm' },
	            'Heads up!'
	          ),
	          ' Hack Happy Valley is now Hack Pennsylvania, PA\u2019s largest high school hackathon. Registration has moved there.'
	        ),
	        _react2.default.createElement(
	          _Action2.default,
	          {
	            href: 'https://hackpenn.com',
	            bg: 'warm',
	            my: 4,
	            is: 'a',
	            analytics: 'email'
	          },
	          'Check out the new event \xBB'
	        )
	      ),
	      _react2.default.createElement(
	        Sheet,
	        {
	          p: [3, 4],
	          bg: 'coolWash',
	          align: 'center',
	          maxWidth: 24,
	          boxShadowSize: 'md'
	        },
	        _react2.default.createElement(
	          _designSystem.Heading.h2,
	          { f: 3, caps: true, mb: 2 },
	          'Share it!'
	        ),
	        _react2.default.createElement(ShareButton, {
	          service: 'Twitter',
	          href: twitterURL('Check out @hackpenn, PA’s largest high school hackathon!', url),
	          bg: '#1da1f2',
	          mr: 3
	        }),
	        _react2.default.createElement(ShareButton, { service: 'Facebook', href: facebookURL(url), bg: '#3b5998' })
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-register-js-2bd1cda96a184bb8c002.js